import './App.css';
import { useState } from 'react';
// import { isCPF } from 'validation-br';
import { useCookies } from "react-cookie";
import { HiOutlineLockClosed } from "react-icons/hi";
import { useNavigate } from 'react-router-dom'
import Loading from './components/Loading/Loading.js'
import BannerHome from './components/Banners/BannerHome/BannerHome.js'
import BannerHomePhone from './components/Banners/BannerHomePhone/BannerHomePhone.js'
import Input from './components/Input/input';
import Button from './components/Button/button';
import Checkbox from './components/CheckBox/checkbox';
import axios from 'axios';
import api from './services/api';
import * as EmailValidator from 'email-validator';

import ReactDOM from "react-dom";

function Home() {
    // console.log(window)
    const [ww, setW] = useState(window.screen.width);
    const [hh, setH] = useState(window.screen.height);

    const [isShow, setShow] = useState(false);

    const [cookies] = useCookies(['__gtm_campaign_url']);
    const [fieldsValidity, setFieldsValidity] = useState([]); // Inicializa o array de erros
    const [isChecked, setIsChecked] = useState(true)
    const [payload, setPayload] = useState([]);
    const navigate = useNavigate();

    // INICIO: payloadStorage
    const payloadSended = sessionStorage.getItem("payloadSendedIdentificacao")
    const payloadStorage = JSON.parse(payloadSended);
    // console.log("payloadSendedIdentificacao", payloadStorage);
                            
    // FINAL: payloadStorage
    
    function convertCookie(cookieUrl) {
        const rawParams = cookieUrl?.split("?")?.[1]?.split("&");
        const wantedParams = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_id",
            "utm_content",
            "utm_term",
            "gclid",
            "fbclid",
            "aff_click_id",
        ];

        const cleanParams = {}

        if (rawParams) {
            for (const rawParam of rawParams) {

                const [key, value] = rawParam.split("=");

                // eslint-disable-next-line eqeqeq
                if (key == 'aff_click_id') {
                    axios.get(`https://api.vsboon.com.br/reward/delivery/savvi?aff_click_id=${value}&action_type=Inapp`)
                        .then(() => {
                            //   console.log('deu certo')
                        })
                        .catch(() => {
                            //   console.log('deu errado')
                        })
                }
                if (key && value && wantedParams.includes(key)) {

                    cleanParams[key] = value;
                }
            }
            return cleanParams;
        }

        return {};
    }


    let button = document.querySelector(".continuar");
    let spinnerButon = "continuar"

    async function handleSubmit(e) {
        e.preventDefault();
        const errors = handleOnBlur(payload, "submit");

        if (errors.length === 0) {
            const cpf = payload.cpf.replace(".", "").replace(".", "").replace("-", "")
            const validation_client_phone = payload.WhatsApp.replace("(", "").replace(")", "").replace("-", "")
            
            // const validation_dt_nascimento = payload.dtnascimento.split('/')
            // const dt_nascimento = validation_dt_nascimento[2] + "-" + validation_dt_nascimento[1] + "-" + validation_dt_nascimento[0]

            const dt_nascimento = payload.dtnascimento;
            
            const nome = payload.UserName
            const email = payload.Email
            const nomeSobrenome = /\w+\s+\w/
            const validarCpf = require('validar-cpf');
            // console.log(validarCpf(cpf))
            if (validarCpf(cpf) === true) {//Valida o CPF, caso invalido, nao passa o usuario de pagina
                if (validation_client_phone.length === 12) {// Valida se o numero do whatsapp tem 12 caracteres

                        if ((nomeSobrenome.test(nome))) {// valida se o campo Nome tem 2 palavras e 1 espaço
                            // eslint-disable-next-line eqeqeq
                            if (email == undefined || EmailValidator.validate(email)) {
                                const celular = validation_client_phone.replace(" ", "")
                                const cookieParams = convertCookie(cookies.__gtm_campaign_url);
                                // getToken()
                                const sendbackend = {
                                    nome,
                                    cpf,
                                    dt_nascimento,
                                    celular,
                                    email,
                                    utm_campaign: (cookieParams.utm_campaign || ""),
                                    utm_medium: (cookieParams.utm_medium || ""),
                                    utm_source: (cookieParams.utm_source || ""),
                                    utm_id: (cookieParams.utm_id || ""),
                                    utm_content: (cookieParams.utm_content || ""),
                                    utm_term: (cookieParams.utm_term || ""),
                                    gclid: (cookieParams.gclid || ""),
                                    fbclid: (cookieParams.fbclid || ""),
                                    aff_click_id: (cookieParams.aff_click_id || ""),
                                }

                                
                                const JsonArray = JSON.stringify(sendbackend)
                                const json_obj = JSON.parse(JsonArray)
                                
                                setShow(true);
                                sessionStorage.setItem("payloadSendedIdentificacao", JsonArray);
                                sessionStorage.setItem("nomeUsuario", nome);
                                
                                sessionStorage.setItem("payload_first_name", nome);
                                sessionStorage.setItem("payload_last_name", nomeSobrenome);
                                sessionStorage.setItem("payload_email", email);
                                sessionStorage.setItem("payload_phone", celular);

                                api.post('/crefaz/create', json_obj, {
                                    
                                })
                                    .then((response) => {
                                        window.dataLayer.push({
                                            event: "fgts-form-success",
                                            email: email,
                                            phone_number: `+55${celular}`,
                                            "address.first_name": nome.split(" ")?.[0],
                                            "address.last_name": nome.split(" ")?.[1],
                                            "address.country": "Br",

                                        });
                                        const encode = response.data.encode_data
                                        const id = response.data.id
                                        sessionStorage.setItem("encode_data", encode);
                                        sessionStorage.setItem("id", id);
                                        navigate("/endereco")
                                        setShow(false);
                                    })
                                    .catch(() => {
                                        setShow(false);
                                        console.log("erro")
                                        navigate("/contato")
                                        button.disabled = false;
                                    })
                            } else {
                                errors.push({
                                    prop: "Email",
                                    errorMessage: "Insira um email válido"
                                })
                            }

                        } else {
                            errors.push({
                                prop: "UserName",
                                errorMessage: "Insira seu Nome e Sobrenome"
                            })
                        }
                } else {
                    errors.push({
                        prop: "WhatsApp",
                        errorMessage: "Insira um numero de WhatsApp Valido."
                    })
                }
            }
            if (validarCpf(cpf) === false) {
                errors.push({
                    prop: "cpf",
                    errorMessage: "CPF inválido. Verifique os digitos inseridos."
                })
            }
        }
    }

    
    const handleOnBlur = (e, prop) => {//e = valor digitado, prop =  nome do input 
        const errors = [];
        if ((prop === "UserName" && !e?.target?.value) || (prop === "submit" && !e?.UserName)) {
            errors.push({
                prop: "UserName",
                errorMessage: "Insira seu nome completo"
            })
        }
        if ((prop === "cpf" && !e?.target?.value) || (prop === "submit" && !e?.cpf)) {
            errors.push({
                prop: "cpf",
                errorMessage: "Insira seu CPF"
            })
        }
        if ((prop === "dtnascimento" && !e?.target?.value) || (prop === "submit" && !e?.dtnascimento)) {
            errors.push({
                prop: "dtnascimento",
                errorMessage: "Insira sua data de nascimento"
            })
        }
        if ((prop === "WhatsApp" && !e?.target?.value) || (prop === "submit" && !e?.WhatsApp)) {
            errors.push({
                prop: "WhatsApp",
                errorMessage: "Insira seu número do WhatsApp"
            })
        } if ((prop === "Email" && !e?.target?.value) || (prop === "submit" && !e?.WhatsApp)) {
            errors.push({
                prop: "Email",
                errorMessage: "Insira seu endereço de Email"
            })
        }
        setFieldsValidity(errors)

        return errors;
    }

    const handleChangeInputs = (value, prop) => {
        setPayload({ ...payload, [prop]: value })
    }

    const validadata = (e) => {
        var data = e.target.value;
        var data_array = data.split("/");
        data = data_array[2] + "-" + data_array[1] + "-" + data_array[0];
        // console.log(data_array);
        var hoje = new Date();
        var nasc = new Date(data);
        var idade = hoje.getFullYear() - nasc.getFullYear();
        var m = hoje.getMonth() - nasc.getMonth();
        if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;
        if (parseInt(idade) < 38) {
            sessionStorage.setItem("idadeMaior", false);
            console.log("Menor de 38 anos");
            return false;
        }
    
        if (parseInt(idade) >= 38) {
            sessionStorage.setItem("idadeMaior", true);
            console.log("Maior de 38 anos");
            return true;
        }
        return false;
    }
    const exceptThisSymbols = ["+", "-", ".", "=", "!", "@", "#", "$", "%", "&", "*", "(", ")", "_", "[", "]", "{", "}", "'", "?", "/"];
    return (
        <div className="home">
            <div className='mobile'>{isShow && <Loading />}</div>
            
            <BannerHome />
            <BannerHomePhone />
            
            <form
                className='container2'
                onSubmit={handleSubmit}
            >


                <div className='form'>
                    <div className='titleform'>
                        <h4 className='titleMob'>Preencha os campos abaixo com seus dados pessoais</h4>
                    </div>
                    <div className='spaceform'></div>
                    <div className='Input-form'>
                        <div className='group'>
                            <label className='label'><b>Nome completo</b></label>
                            <Input
                                onChange={ (e) => handleChangeInputs(e.target.value, "UserName")}
                                onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                name="UserName"
                                id="UserName"
                                length="150"
                                type="text"
                                placeholder='Nome completo'
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}
                                autoFocus
                            />
                        </div>
                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>CPF</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "cpf")}
                                inputmode="numeric"
                                name="cpf"
                                id="cpf"
                                keyboard="numeric"
                                mask="999.999.999-99"
                                type="text"
                                length="28"
                                placeholder='000.000.000-00'
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}

                            />
                        </div>

                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>Data de nascimento</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "dtnascimento")}
                                name="dtnascimento"
                                id="dtnascimento"
                                keyboard="numeric"
                                mask="99/99/9999"
                                type="text"
                                length="10"
                                placeholder='00/00/0000'
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur && validadata}

                            />
                        </div>

                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>WhatsApp</b> (com DDD)</label>

                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "WhatsApp")}
                                name="WhatsApp"
                                type="text"
                                placeholder='(00) 00000-0000'
                                length="28"
                                mask="(99) 99999-9999"
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}

                            />
                        </div>
                        <div className='spaceform'></div>
                        <div className='group'>
                            <label className='label'><b>Email</b></label>
                            <Input
                                onChange={(e) => handleChangeInputs(e.target.value, "Email")}
                                name="Email"
                                type="text"
                                placeholder='email@dominio.com'
                                error={fieldsValidity}
                                handleOnBlur={handleOnBlur}
                            />
                            {/* <p className='pemail'>O email é nossa melhor forma de comunicação.</p> */}
                        </div>

                        <div className='spaceform'></div>

                        <div className='group'>
                            <Checkbox
                                isChecked={isChecked}
                                setIsChecked={setIsChecked}
                            />
                        </div>
                        <div className='spacer1'></div>
                        <Button
                            message='SOLICITAR SIMULAÇÃO'
                            className={spinnerButon}
                            isChecked={isChecked}
                        />

                        <div className='textfooterMobile'>
                            <div className='locked'><HiOutlineLockClosed /></div>
                            <h6>Você está em um ambiente seguro.</h6>
                        </div>

                    </div>
                </div>

                
            </form>
        </div>
    );
}

export default Home;